/* eslint-disable no-confusing-arrow */
/** Utility function to add pixel adjustment to canvas fillRect method */
export const fillRect = (ctx, x, y, w, h) => {
	ctx.fillRect(
		Math.round(x),
		Math.round(y),
		Math.round(w) + 1,
		Math.round(h) + 1
	);
};

export const roundRect = (ctx, x, y, w, h, radii) => {
	ctx.roundRect(
		Math.round(x),
		Math.round(y),
		Math.round(w) + 1,
		Math.round(h) + 1,
		radii
	);
};

/**
 * Method to adjust value for canvas subpixel offset
 * @param {number} val
 * @param {Boolean} roundUp - Whether or not to round the value up. True rounds up, false rounds down.
 * @return {number}
 */
export const px = (val, roundUp = true) => roundUp ? Math.round(val) + 0.5 : Math.round(val) - 0.5;

/** Utility function to add pixel adjustment to canvas rect method for hollow candles */
export function hollowRect(ctx, x, y, w, h) {
	const h2 = h < 0 ? Math.min(-1, h) : Math.max(1, h); // enforce 1px height for IE11 (NXC-766)
	ctx.rect(px(x), px(y), Math.round(w), h2);
}

/** Utility method to draw a canvas line with pixel offset applied */
export const lineTo = (ctx, x, y) => ctx.lineTo(px(x), px(y));

/** Utility method to move the pointer with pixel offset applied */
export const moveTo = (ctx, x, y) => ctx.moveTo(px(x), px(y));

/**
 * Canvas rectangle utility function
 * @param {CanvasRenderingContext2D} ctx
 * @param {int} x
 * @param {int} y
 * @param {int} w - rectangle width
 * @param {int} h - rectangle height
 */
export const rect = (ctx, x, y, w, h) => ctx.rect(px(x), px(y), Math.round(w), Math.round(h));

/** Utility function to add pixel adjustment to canvas strokeRect method */
export const strokeRect = (ctx, x, y, w, h) => ctx.strokeRect(px(x), px(y), Math.round(w), Math.round(h));

export default {
	fillRect,
	hollowRect,
	roundRect,
	lineTo,
	moveTo,
	px,
	rect,
	strokeRect
};
